import PulseIcon from '../../../assets/svg/Pulse.svg?react';
import PastProjectionsIcon from '../../../assets/svg/PastProjections.svg?react';
import GlobalIndexIcon from '../../../assets/svg/GlobalIndex.svg?react';
import { FGIcons, FGTypography } from '@fg/design-system';
import { IExportChartConfig, RISK_CHART_MODES, GRAPH_VIEWS } from 'interfaces';
import { getGlobalIndexColor, getGlobalIndexLabel } from '../templateUtils';

const labelValueStyle = {
    textTransform: 'capitalize',
    color: 'var(--fg-color-text)',
    fontWeight: 600,
};

interface Props {
    chartConfig: IExportChartConfig;
}

const ExportChartLegends = ({ chartConfig }: Props) => {
    const {
        riskChartMode,
        currencyOn,
        projectionDataOn,
        viewType,
    } = chartConfig;

    if (!GRAPH_VIEWS.includes(viewType)) {
        return null;
    }

    const legends = [];

    if (
        riskChartMode === RISK_CHART_MODES.RISK ||
        riskChartMode === RISK_CHART_MODES.RISK_AND_PULSE
    ) {
        legends.push({ icon: <FGIcons icon="Delete" />, text: 'Composite' });
    }

    if (
        riskChartMode === RISK_CHART_MODES.PULSE ||
        riskChartMode === RISK_CHART_MODES.RISK_AND_PULSE
    ) {
        legends.push({ icon: <PulseIcon />, text: 'Pulse' });
    }

    if (projectionDataOn) {
        legends.push({
            icon: <PastProjectionsIcon />,
            text: 'Past Projections',
        });
    }

    if (currencyOn) {
        const currencyCountry = chartConfig.currencyCountry[0];
        const currencyCode =
            chartConfig.displayNames.countries[currencyCountry].currency_code;

        legends.push({
            icon: (
                <span
                    style={{
                        color: chartConfig.colorsStack.countries.find(
                            c => c.key === currencyCountry
                        )?.color,
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                    <GlobalIndexIcon />
                </span>
            ),
            text: `Currency (${currencyCode})`,
        });
    } else if (chartConfig.globalIndexTypes?.length > 0) {
        const globalIndexColor = getGlobalIndexColor(chartConfig);
        const globalIndexLabel = getGlobalIndexLabel(chartConfig);
        legends.push({
            text: globalIndexLabel,
            icon: (
                <span
                    style={{
                        color: globalIndexColor,
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                    <GlobalIndexIcon />
                </span>
            ),
        });
    }
    return (
        <div className="gq-template-component-legends-v2">
            {legends.map(({ text, icon }) => (
                <div
                    className="gq-template-component-legend-v2"
                    style={{ ...labelValueStyle }}
                    key={text}>
                    {icon}
                    <FGTypography tag="label" variant="label2">
                        {text}
                    </FGTypography>
                </div>
            ))}
        </div>
    );
};

export default ExportChartLegends;
